module.exports = __webpack_public_path__ + "media/images/banner/klook/pc/rental-o_770_280_id-f91c7997114ccf9e66061b474efe2f3b.jpg";